export function redirectTo(path) {
    window.location.replace(path);
}
